// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2jl6M","countWrapper":"MuXjv"};